export interface DriveItem {
  id: string;
  name: string;
  type: 'file' | 'folder';
  mimeType?: string;
  fileType?: string;
  size?: number;
  parentId: string | null;
  path?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export const mockFiles: DriveItem[] = [
  {
    id: 'folder-1',
    name: '문서',
    type: 'folder',
    parentId: null,
    createdAt: '2026-07-15T09:00:00Z',
    updatedAt: '2026-08-05T14:30:00Z',
  },
  {
    id: 'folder-2',
    name: '이미지',
    type: 'folder',
    parentId: null,
    createdAt: '2026-06-20T11:00:00Z',
    updatedAt: '2026-08-01T10:15:00Z',
  },
  {
    id: 'folder-3',
    name: '비디오',
    type: 'folder',
    parentId: null,
    createdAt: '2026-07-01T08:00:00Z',
    updatedAt: '2026-07-28T16:45:00Z',
  },
  {
    id: 'folder-4',
    name: '프로젝트',
    type: 'folder',
    parentId: null,
    createdAt: '2026-05-10T13:00:00Z',
    updatedAt: '2026-08-06T09:20:00Z',
  },
  {
    id: 'folder-5',
    name: '백업',
    type: 'folder',
    parentId: null,
    createdAt: '2026-04-01T07:30:00Z',
    updatedAt: '2026-07-15T11:00:00Z',
  },
  {
    id: 'file-1',
    name: 'README.md',
    type: 'file',
    mimeType: 'text/markdown',
    size: 2456,
    parentId: null,
    createdAt: '2026-08-01T10:00:00Z',
    updatedAt: '2026-08-01T10:00:00Z',
  },
  {
    id: 'file-2',
    name: 'Todo리스트.txt',
    type: 'file',
    mimeType: 'text/plain',
    size: 890,
    parentId: null,
    createdAt: '2026-07-28T09:30:00Z',
    updatedAt: '2026-08-05T08:00:00Z',
  },
  {
    id: 'doc-1',
    name: '2026년 업무 계획서.docx',
    type: 'file',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    size: 158200,
    parentId: 'folder-1',
    createdAt: '2026-07-20T14:00:00Z',
    updatedAt: '2026-08-03T11:30:00Z',
  },
  {
    id: 'doc-2',
    name: '회의록_7월.pdf',
    type: 'file',
    mimeType: 'application/pdf',
    size: 320500,
    parentId: 'folder-1',
    createdAt: '2026-07-25T16:00:00Z',
    updatedAt: '2026-07-25T16:00:00Z',
  },
  {
    id: 'doc-3',
    name: '예산_분기별.xlsx',
    type: 'file',
    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    size: 45200,
    parentId: 'folder-1',
    createdAt: '2026-07-10T10:00:00Z',
    updatedAt: '2026-08-01T09:00:00Z',
  },
  {
    id: 'doc-4',
    name: '프레젠테이션_제안서.pptx',
    type: 'file',
    mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    size: 2450000,
    parentId: 'folder-1',
    createdAt: '2026-07-18T13:00:00Z',
    updatedAt: '2026-07-30T15:00:00Z',
  },
  {
    id: 'doc-5',
    name: '계약서_초안.pdf',
    type: 'file',
    mimeType: 'application/pdf',
    size: 180300,
    parentId: 'folder-1',
    createdAt: '2026-06-15T09:00:00Z',
    updatedAt: '2026-06-20T14:00:00Z',
  },
  {
    id: 'doc-6',
    name: '서버_설정_가이드.md',
    type: 'file',
    mimeType: 'text/markdown',
    size: 5100,
    parentId: 'folder-1',
    createdAt: '2026-08-02T11:00:00Z',
    updatedAt: '2026-08-06T16:00:00Z',
  },
  {
    id: 'img-1',
    name: '여행_사진_001.jpg',
    type: 'file',
    mimeType: 'image/jpeg',
    size: 3200000,
    parentId: 'folder-2',
    createdAt: '2026-07-05T08:00:00Z',
    updatedAt: '2026-07-05T08:00:00Z',
  },
  {
    id: 'img-2',
    name: '프로필_사진.png',
    type: 'file',
    mimeType: 'image/png',
    size: 850000,
    parentId: 'folder-2',
    createdAt: '2026-06-30T12:00:00Z',
    updatedAt: '2026-07-01T09:00:00Z',
  },
  {
    id: 'img-3',
    name: '제품_샘플.webp',
    type: 'file',
    mimeType: 'image/webp',
    size: 520000,
    parentId: 'folder-2',
    createdAt: '2026-07-12T15:00:00Z',
    updatedAt: '2026-07-12T15:00:00Z',
  },
  {
    id: 'img-4',
    name: '인테리어_참고.jpg',
    type: 'file',
    mimeType: 'image/jpeg',
    size: 4100000,
    parentId: 'folder-2',
    createdAt: '2026-07-20T10:00:00Z',
    updatedAt: '2026-07-20T10:00:00Z',
  },
  {
    id: 'img-5',
    name: '로고_디자인_최종.png',
    type: 'file',
    mimeType: 'image/png',
    size: 1200000,
    parentId: 'folder-2',
    createdAt: '2026-08-01T14:00:00Z',
    updatedAt: '2026-08-04T11:00:00Z',
  },
  {
    id: 'img-6',
    name: '스크린샷_20260806.png',
    type: 'file',
    mimeType: 'image/png',
    size: 2450000,
    parentId: 'folder-2',
    createdAt: '2026-08-06T17:00:00Z',
    updatedAt: '2026-08-06T17:00:00Z',
  },
  {
    id: 'vid-1',
    name: '튜토리얼_영상.mp4',
    type: 'file',
    mimeType: 'video/mp4',
    size: 45000000,
    parentId: 'folder-3',
    createdAt: '2026-07-08T09:00:00Z',
    updatedAt: '2026-07-08T09:00:00Z',
  },
  {
    id: 'vid-2',
    name: '발표_녹화.mov',
    type: 'file',
    mimeType: 'video/quicktime',
    size: 120000000,
    parentId: 'folder-3',
    createdAt: '2026-07-15T14:00:00Z',
    updatedAt: '2026-07-15T14:00:00Z',
  },
  {
    id: 'vid-3',
    name: 'bgm_작업용.mp3',
    type: 'file',
    mimeType: 'audio/mpeg',
    size: 8500000,
    parentId: 'folder-3',
    createdAt: '2026-07-22T11:00:00Z',
    updatedAt: '2026-07-22T11:00:00Z',
  },
  {
    id: 'proj-1',
    name: '웹드라이브',
    type: 'folder',
    parentId: 'folder-4',
    createdAt: '2026-08-01T08:00:00Z',
    updatedAt: '2026-08-06T18:00:00Z',
  },
  {
    id: 'proj-2',
    name: '대시보드_앱',
    type: 'folder',
    parentId: 'folder-4',
    createdAt: '2026-06-10T09:00:00Z',
    updatedAt: '2026-07-20T16:00:00Z',
  },
  {
    id: 'proj-3',
    name: 'API_서버',
    type: 'folder',
    parentId: 'folder-4',
    createdAt: '2026-05-15T10:00:00Z',
    updatedAt: '2026-07-30T12:00:00Z',
  },
  {
    id: 'proj-spec-1',
    name: '요구사항_정의서.md',
    type: 'file',
    mimeType: 'text/markdown',
    size: 8200,
    parentId: 'proj-1',
    createdAt: '2026-08-01T10:00:00Z',
    updatedAt: '2026-08-03T14:00:00Z',
  },
  {
    id: 'proj-spec-2',
    name: '와이어프레임.pdf',
    type: 'file',
    mimeType: 'application/pdf',
    size: 1200000,
    parentId: 'proj-1',
    createdAt: '2026-08-02T15:00:00Z',
    updatedAt: '2026-08-02T15:00:00Z',
  },
  {
    id: 'proj-spec-3',
    name: 'DB_스키마.sql',
    type: 'file',
    mimeType: 'text/plain',
    size: 3400,
    parentId: 'proj-1',
    createdAt: '2026-08-04T09:00:00Z',
    updatedAt: '2026-08-05T11:00:00Z',
  },
  {
    id: 'backup-1',
    name: 'db_backup_20260715.sql.gz',
    type: 'file',
    mimeType: 'application/gzip',
    size: 25000000,
    parentId: 'folder-5',
    createdAt: '2026-07-15T02:00:00Z',
    updatedAt: '2026-07-15T02:00:00Z',
  },
  {
    id: 'backup-2',
    name: 'db_backup_20260801.sql.gz',
    type: 'file',
    mimeType: 'application/gzip',
    size: 28500000,
    parentId: 'folder-5',
    createdAt: '2026-08-01T02:00:00Z',
    updatedAt: '2026-08-01T02:00:00Z',
  },
  {
    id: 'backup-3',
    name: 'config_backup.tar.gz',
    type: 'file',
    mimeType: 'application/gzip',
    size: 1500000,
    parentId: 'folder-5',
    createdAt: '2026-07-20T03:00:00Z',
    updatedAt: '2026-07-20T03:00:00Z',
  },
];

export const totalStorage = 107374182400;
export const usedStorage = 28560000000;

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = (bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1);
  return `${size} ${units[i]}`;
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (days === 0) return '오늘';
  if (days === 1) return '어제';
  if (days < 7) return `${days}일 전`;
  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function getFileIcon(mimeType?: string): string {
  if (!mimeType) return 'ri-file-3-line';
  if (mimeType.startsWith('image/')) return 'ri-image-line';
  if (mimeType.startsWith('video/')) return 'ri-video-line';
  if (mimeType.startsWith('audio/')) return 'ri-music-line';
  if (mimeType.includes('pdf')) return 'ri-file-pdf-2-line';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'ri-file-word-2-line';
  if (mimeType.includes('spreadsheet') || mimeType.includes('excel')) return 'ri-file-excel-2-line';
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return 'ri-file-ppt-2-line';
  if (mimeType.includes('zip') || mimeType.includes('gzip') || mimeType.includes('rar')) return 'ri-file-zip-line';
  if (mimeType.startsWith('text/') || mimeType.includes('markdown') || mimeType.includes('json')) return 'ri-file-text-line';
  if (mimeType.includes('sql')) return 'ri-database-2-line';
  return 'ri-file-3-line';
}

export function getFileColor(mimeType?: string): string {
  if (!mimeType) return 'text-secondary-500';
  if (mimeType.startsWith('image/')) return 'text-accent-500';
  if (mimeType.startsWith('video/')) return 'text-primary-500';
  if (mimeType.startsWith('audio/')) return 'text-primary-400';
  if (mimeType.includes('pdf')) return 'text-accent-600';
  if (mimeType.includes('word') || mimeType.includes('document')) return 'text-primary-600';
  if (mimeType.includes('spreadsheet') || mimeType.includes('excel')) return 'text-primary-500';
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return 'text-accent-500';
  return 'text-secondary-500';
}
